import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../state/app.state";
import {profileData} from "../../../shared/core/shared.selectors";
import {roleUrlMap} from "../../../shared/constants/common.constants";
import {CommonService} from "../../../shared/services/common.service";

@Component({
  selector: 'app-screen',
  templateUrl: './manage-users-screen.component.html',
  styleUrls: ['./manage-users-screen.component.css']
})
export class ManageUsersScreenComponent {
  private readonly onDestroy: Subject<any> = new Subject<any>();
  role;

  isDrilldown = false;

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private route: ActivatedRoute
  ) {
    const params: any = this.route.snapshot.params;

    const userId = params?.clientAdminId ||
                   params?.coachId ||
                   params?.memberId;

    this.isDrilldown = !!userId;

    this.store.select(profileData)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.role = data.profile?.role
      });
  }

  ngOnInit() {
    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });
  }

  OnInvite() {
    this.router.navigate([`/${roleUrlMap[this.role]}/invite`]);
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
